<template>
  <b-container fluid >
    <b-row>
    <b-col md="12">
      <div class="iq-card p-3 row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
          <h4><i class="fa fa-bug" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp; {{cvCardTitle}}</h4><br>
          <h5>Name:&nbsp;<span>{{appData && appData.app_name}}</span></h5>
          <h6><small>App Type:&nbsp;<span>{{appData && appData.app_type}}</span></small></h6>
          <h6><small>Category:&nbsp;<span>{{appData && appData.app_category}}</span></small></h6>
          <p class="primary-color">
            Name:&nbsp;{{user && user.user_name}} <br/>
            Id:&nbsp;{{user && user.user_id}} <br/>
            Email:&nbsp;{{user && user.user_email}} <br/>
          </p>
        </div>
      </div>
      <div class="iq-card row p-3">
        <b-col class="container_minheight" md="12" v-if="resultFixListObj && resultFixListObj.length > 0">
          <b-table
            hover
            responsive
            :items="resultFixListObj"
            :fields="columns"
            :no-border-collapse="true"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(app_name)="data">
              <span>
                <span class="mr-2">{{data.item.app_name}}</span><i class="fa fa-edit font-size-16 mr-4 pointer" title="Edit Result" @click="gotoQuizEdit(data.item.app_id)"></i><br>
                <small>
                  App Id:&nbsp;{{data.item.app_id}}<br>
                  Result Id:&nbsp;{{data.item.aprs_id}}<br>
                  Assessment Date:&nbsp;{{data.item.created_on | dateFormatDDMMYYYYHHMMA}}<br>
                </small><br><br>
                <i class="fa fa-trash-o font-size-20 mr-4 pointer" title="Delete Result" @click="deleteQuizAnswers(data.item.aprs_id)"></i>
                <i class="fa fa-refresh font-size-20 mr-4 pointer" title="Restore Result" @click="restoreQuizAnswers(data.item.aprs_id)"></i>
                <i class="fa-solid fa fa-check-circle font-size-20 mr-4 pointer" title="Analyse Responses" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="openInBrowser('CAREER', data.item)"></i>
                <i class="fa-solid fa-magnifying-glass-chart font-size-20 mr-4 pointer" title="Assessment Review" v-if="(userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118') && (VUE_APP_ENV !== 'prod')" @click="openInBrowserV1('CAREER', data.item)"></i>
                <i class="fa-solid fa-sliders font-size-20 mr-4 pointer" title="Toggle Quiz Session Status: Inprogress/Completed" v-if="(userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118') && data.item.status == 'INPROGRESS'" @click="changeQuizSessionStatus(data.item)"></i>
                <i class="fas fa-database font-size-20 mr-4 pointer" title="Sync Answer Categories" v-if="(userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118') && data.item.status == 'COMPLETED' && data.item.deleted === 0" @click="appQuizAnswerCategorySync(data.item)"></i>
                <b-badge v-if="data.item.deleted === 1" class="pointer" variant="primary mr-4">Deleted</b-badge>
                <b-badge v-if="data.item.deleted === 0" class="pointer" variant="success mr-4">Active</b-badge>
                 <b-badge v-if="data.item.status === 'INPROGRESS'" class="pointer" variant="warning mr-4">Inprogress</b-badge>
                 <b-badge v-if="data.item.status === 'COMPLETED'" class="pointer" variant="info mr-4">Completed</b-badge>
              </span>
            </template>

            <template v-slot:cell(aprs_id)="data">
              <small>
                {{data.item.aprs_id}}&nbsp;&nbsp;
                <i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.aprs_id)"></i>
              </small>
            </template>
          </b-table>
        </b-col>
        <b-col class="container_minheight" md="12" v-else>
          No data found
        </b-col>
        <b-col sm="7" md="8" class="my-1"></b-col>
        <b-col sm="5" md="4" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </div>
    </b-col>
  </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { QuizAnswers } from "../../../FackApi/api/quizAnswers.js"
import userPermission from "../../../Utils/user_permission.js"
import Utility from "../../../Utils/utility.js"
import { AppResults } from "../../../FackApi/api/appResults"

export default {
  name: "AppResultListFix",
  data () {
    return {
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      app_id: null,
      user_id: null,
      resultFixListObj: null,
      appData: null,
      user: null,
      apiName: "quiz_answers_aprs_list",
      cvCardTitle: "Debug & Fix Quiz Results",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "App Result List Response",
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "App", key: "app_name", class: "text-left align-text-top", sortable: true },
        { label: "Questions Attempted", key: "question_count", class: "text-left align-text-top", sortable: true }
      ],
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      userID: null,
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    if (this.$route.params.user_id) {
      this.userID = this.$route.params.user_id
    }
    socialvue.index()
    this.getAllAvailableResults()
  },
  methods: {
    /**
     *
     */
    async getAllAvailableResults () {
      try {
        console.log({ app_id: this.$route.params.app_id, user_id: this.$route.params.user_id })
        let resultList = await QuizAnswers.quizAnswersAprsList(this, { app_id: this.$route.params.app_id, user_id: this.$route.params.user_id })
        if (!resultList.resp_status) {
          this.toastMsg = "Data not found"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        this.resultFixListObj = resultList.resp_data.data
        this.appData = resultList.app_data
        this.user = resultList.user_data
      }
      catch (err) {
        console.error("Exception in getAllAvailableResults and err: ", err)
      }
    },
    /**
     * deleteQuizAnswers
     */
    async deleteQuizAnswers (aprsId) {
      try {
        const deleteResp = await QuizAnswers.quizAnswersDelete(this, { aprs_id: aprsId, qns_id: "NA", app_id: this.appData.app_id, app_category: this.appData.app_category, gide_user_id: this.$route.params.user_id, fixing_result: true })
        if (!deleteResp.resp_status) {
          this.toastMsg = "Unable to delete answers"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        this.toastMsg = deleteResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
        this.getAllAvailableResults()
      }
      catch (err) {
        console.error("Exception in deleteQuizAnswers and err: ", err)
      }
    },
    /**
     * restoreQuizAnswers
     */
    async restoreQuizAnswers (aprsId) {
      try {
        let restoreQuizResp = await QuizAnswers.quizAnswersRestore(this, { aprs_id: aprsId, qns_id: "NA", app_id: this.appData.app_id, app_category: this.appData.app_category, gide_user_id: this.$route.params.user_id })
        if (!restoreQuizResp.resp_status) {
          this.toastMsg = "Unable to restore results"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        this.toastMsg = restoreQuizResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
        this.getAllAvailableResults()
      }
      catch (err) {
        console.error("Exception in restoreQuizAnswers and err: ", err)
      }
    },
    /**
     * changeQuizSessionStatus
     * Toggles the status of quiz session: Inprogress/Completed
     */
    async changeQuizSessionStatus (result) {
      try {
        const payload = {
          aprs_id: result.aprs_id,
          status: result.status == "INPROGRESS" ? "COMPLETED" : "INPROGRESS"
        }

        let appsResultsAllEditResp = await AppResults.appResultsAllEdit(this, payload)
        if (!appsResultsAllEditResp.resp_status) {
          this.toastMsg = "Unable to toggle status of quiz session"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = appsResultsAllEditResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
        this.getAllAvailableResults()
      }
      catch (err) {
        console.error("Exception in changeQuizSessionStatus and err: ", err)
      }
    },
    /**
     *  open In Browser
     *  Append the classGrade to GPathData.GPATH_CAREER, GPathData.GPATH_SKILL, GPathData.GPATH_APTITUDE, GPathData.GPATH_COUNSELLOR if class <= 8
     */
    openInBrowser (type, sessionData) {
      let productIdAlias = sessionData.app_id.replace("APPGPATHPRODUCTID", "")

      let url = ""
      switch (type) {
        case "CAREER":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=NA`
          break
        case "SKILL":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=NA`
          break
        case "APTITUDE":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=NA`
          break
        case "EXTRACURRICULAR":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=NA`
          break
        default:
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=NA`
          break
      }

      window.open(url, "_blank")
    },
    /**
     *  open In Browser V1
     *  Append the classGrade to GPathData.GPATH_CAREER, GPathData.GPATH_SKILL, GPathData.GPATH_APTITUDE, GPathData.GPATH_COUNSELLOR if class <= 8
     */
    openInBrowserV1 (type, sessionData) {
      let productIdAlias = sessionData.app_id.replace("APPGPATHPRODUCTID", "")

      let url = ""
      switch (type) {
        case "CAREER":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse_v1/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=${sessionData.attempt}`
          break
        case "SKILL":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse_v1/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=${sessionData.attempt}`
          break
        case "APTITUDE":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse_v1/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=${sessionData.attempt}`
          break
        case "EXTRACURRICULAR":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse_v1/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=${sessionData.attempt}`
          break
        default:
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse_v1/${productIdAlias}/${this.userID}/${sessionData.aprs_id}?attempt=${sessionData.attempt}`
          break
      }

      window.open(url, "_blank")
    },
    /**
     *  goto QuizEdit
     *
     */
    gotoQuizEdit (appId) {
      window.open(`/quiz_edit/${appId}`, "_blank")
    },
    /**
     *  appQuizAnswerCategorySync
     *
     */
    async appQuizAnswerCategorySync (sessionData) {
      try {
        const payload = {
          aprs_id: sessionData.aprs_id
        }

        let appQuizAnswerCategorySyncResp = await AppResults.appQuizAnswerCategorySync(this, payload)
        if (!appQuizAnswerCategorySyncResp.resp_status) {
          this.toastMsg = "Unable to sync answer categories"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = appQuizAnswerCategorySyncResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
      }
      catch (err) {
        console.error("Exception in appQuizAnswerCategorySync and err: ", err)
      }
    }
  }
}
</script>
